export default "/images/f271900760c6d91e404cf9ddd423ab6d.png";